<template>
    <div class="intro">
        <v-layout row wrap>
            <v-flex xs1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <router-link to="/"><img class="ui-btn" src="icons/qa/ui/btnBackward.svg" /></router-link>
                    </div>
                </div>
            </v-flex>
            <v-flex xs10 class="mt-5">
                <div class="display-flex">
                    <div class="center-by-margin">
                        <v-avatar
                            :size="100"
                        >
                            <img
                                    src="images/avatar_knud.jpg"
                                    alt="Knud"
                            >
                        </v-avatar>
                        <p style="width:100%">Ich bin Knud.<br>
                            Jetzt  habe ich ein paar Fragen an dich um zu sehen, wodurch du in deinem Leben ins Stolpern kommen könntest.<br>
                            Anschließend gibt’s dann meine Tipps, wie du ganz entspannt das Gleichgewicht hältst, wenn dir dein Leben doch mal eine Falle stellt
                            Bist du bereit?<br>
                        </p>
                    </div>
                </div>
            </v-flex>
            <v-flex xs1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <router-link to="/fragen"><img class="ui-btn" src="icons/qa/ui/btnForward.svg" /></router-link>
                    </div>
                </div>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
    export default {
        name: "Intro"
    }
</script>

<style>
    .intro {
        width: 100%;
        height: 100%;
        font-size: 32px;
        line-height: 1.5em;
    }
    .display-flex {
        display: flex;
        height: 100%;
    }
    .center-by-margin {
        margin: auto;
    }
    .v-avatar img {
        width: 150px;
    }

</style>
